import React from "react";
import Divider from "components/Divider/Divider";
import CompanyInfoSection from "../../offline-merchant-detail/Component/CompanyInfoSection";
import MerchantInfoSection from "../../offline-merchant-detail/Component/MerchantInfoSection";
import AccountInfoSection from "../../offline-merchant-detail/Component/AccountInfoSection";
import { FormBuilder } from "components/FormBuilder/FormBuilder";

const InfoSection = ({
  formProps,
  isLoading,
  mccDropdownOptions,
  hideAgentFields,
}) => {
  return (
    <FormBuilder.Section padding="0 24px">
      <CompanyInfoSection
        formProps={formProps}
        isCreate
        isLoading={isLoading}
        isEdit={true}
        mccDropdownOptions={mccDropdownOptions}
        hideAgentFields={hideAgentFields}
      />
      <Divider />
      <MerchantInfoSection
        formProps={formProps}
        isCreate
        isLoading={isLoading}
        isEdit={true}
      />
      <Divider />
      {/* <OthersSection
        formProps={formProps}
        isLoading={isLoading}
        isEdit={true}
        dropdownOptions={dropdownOptions}
      /> */}
      {/* <Divider /> */}
      <AccountInfoSection
        formProps={formProps}
        isLoading={isLoading} isEdit={true} />
    </FormBuilder.Section>
  );
};

export default React.memo(InfoSection);


